// Module
var code = "<div class=\"modal\"> <div class=\"modal-bg\" v-on:click=\"$emit('close')\"></div> <div class=\"modal-content\"> <slot></slot> </div> </div> ";
// Exports
export default code;